
		<info-modal [title]="title" (onOk)="ok()">
			<div class="row">
				<div class="col-md-12">
					<chart [data]="chart.data" [options]="chart.options"></chart>
				</div>
			</div>
		</info-modal>
	